// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"17":"edc4a821","70":"4ce1d922","240":"165c6986","413":"f0b787bb","702":"317112b7","868":"17c4ef1c","990":"ca924327"}[chunkId] + ".chunk.js";
};